// extracted by mini-css-extract-plugin
export default {"label":"Search_label__v-K2k","input":"Search_input__HIa65"};